import React from "react";

import Heading from "components/heading";

import VideoPlayer from "components/video-player";

import HeroSection from "../../hero-section";

const title = "Meet Enerflo Virtual Sales Rep (VSR)";

const MeetVsr = () => (
  <div className="bg-gray-100">
    <HeroSection title={title}>
      <div className="grow flex flex-col items-center">
        <HeroSection.Content className="w-full md:text-center mb-16">
          <HeroSection.Header>
            <Heading tag="h2">{title}</Heading>
          </HeroSection.Header>
          <HeroSection.Description className="text-gray-500 max-w-5xl mx-auto">
            Enerflo VSR is the newest innovation from Enerflo designed to help residential solar installers capture more
            qualified leads, accelerate speed-to-lead, and amplify the ROI of your paid and organic marketing efforts.
          </HeroSection.Description>
        </HeroSection.Content>
        <HeroSection.Content className="w-full flex flex-col text-left lg:flex-row lg:items-center gap-x-10 gap-y-14">
          <div className="flex-1 space-y-6">
            <div className="space-y-4">
              <p className="text-lg">
                <strong>
                  Enerflo VSR is the setter that never sleeps, engaging homeowners 24/7 through a clean, intuitive, and
                  fully branded online experience.
                </strong>{" "}
                Whether embedded on your website, used as a landing page for ads, or deployed across multiple marketing
                channels, VSR turns curiosity into qualified opportunities — automatically.
              </p>
            </div>
            <ul className="list-disc list-outside ml-4 space-y-2 text-left xs:grid xs:grid-cols-2 xs:gap-2 xs:space-y-0 lg:block lg:space-y-2">
              <li>Interactive Lead Capture</li>
              <li>Referral Code Setup</li>
              <li>Unlimited Configurations</li>
              <li>Instant Quote Generation</li>
              <li>Automated Lead Delivery</li>
              <li>And more!</li>
            </ul>
          </div>

          <figure className="flex-1">
            <VideoPlayer url="https://www.youtube.com/watch?v=xDxdM81yxE0" className="max-w-2xl mx-auto" />
            <figcaption className="text-center mt-2 text-sm text-gray-500 italic">
              Watch a Demo: See Enerflo VSR in action!
            </figcaption>
          </figure>
        </HeroSection.Content>
      </div>
    </HeroSection>
  </div>
);

export default MeetVsr;
